import { useTeamMembersList } from './hooks/use-team-members-list.hook';
import { useMemo } from 'react';
import { WindowTitle } from '../../../core/window-title/window-title.component';
import { TeamMembersListHeader } from './components/team-members-list-header/team-members-list-header.component';
import { TeamMembersListTable } from './components/team-members-list-table/team-members-list-table.component';
import { ProjectPathParams, Paths } from '../../../app/router/app.router';
import { RestError } from '@azure/core-http';
import { ErrorFullPage } from '../../../ui/components/pure/errors/error-full-page/error-full-page.component';
import { TeamMembersListActionsObserver } from './team-members-list-actions-observer';
import { Container } from '@mui/material';

export function TeamMembersListPage({ params }: { params: ProjectPathParams<Paths.team> }) {
  const { project, team, formData, setFormData, actions, statusOptions } = useTeamMembersList(params.projectID);
  const sortData = useMemo(
    () => ({ sortBy: formData.sortBy, sortOrder: formData.sortOrder }),
    [formData.sortBy, formData.sortOrder]
  );

  const error = project.error || team.error;

  if (error) {
    const entity = project.error ? 'project' : 'team member';

    if ((error as RestError).statusCode === 401) {
      return <ErrorFullPage preset="GLOBAL_ACCESS_DENIED" />;
    }

    if ((error as RestError).statusCode === 403) {
      return <ErrorFullPage preset="ACCESS_DENIED" entity={entity} />;
    }

    if ((error as RestError).statusCode === 404) {
      return <ErrorFullPage preset="NOT_FOUND" entity={entity} />;
    }

    return <ErrorFullPage />;
  }

  return (
    <Container>
      {<WindowTitle detail={project.data?.name} pageTitle="Team Members" />}
      <TeamMembersListHeader
        params={params}
        formData={formData}
        setFormData={setFormData}
        projectName={project.data?.name}
        actions={actions}
        statusOptions={statusOptions}
      />
      <TeamMembersListTable
        params={params}
        rows={team.data || []}
        isLoading={team.isLoading}
        isPreviousData={team.isPreviousData}
        sortData={sortData}
        setFormData={setFormData}
        hasError={team.isError}
      />
      <TeamMembersListActionsObserver params={params} actions={actions} />
    </Container>
  );
}
